import React from "react";

interface IconProps {
  size?: number;
  color?: string;
}

const ExpandMoreIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = "currentColor" 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10l5 5 5-5z"
        fill={color}
      />
    </svg>
  );
};

export default ExpandMoreIcon;